// Globally modifiable in-memory query cache. Just an object.
const queryCache = {};

export function getCachedQuery(key) {
  return queryCache[key] ?? null;
}

export function putCachedQuery(key, value) {
  queryCache[key] = value;
}
